import {
    AriaDescriber,
    FocusMonitor,
} from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import {
    Overlay,
    ScrollDispatcher,
    ScrollStrategy,
} from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import {
    Directive,
    ElementRef,
    Inject,
    NgZone,
    Optional,
    ViewContainerRef,
} from '@angular/core';
import {
    MAT_TOOLTIP_DEFAULT_OPTIONS,
    MAT_TOOLTIP_SCROLL_STRATEGY,
    MatTooltip,
    MatTooltipDefaultOptions,
} from '@angular/material/tooltip';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[matTooltip]',
    exportAs: 'matTooltip',
    // tslint:disable-next-line: no-host-metadata-property
    host: {
        '(longpress)': 'show()',
        '(keydown)': '_handleKeydown($event)',
        '(touchend)': '_handleTouchend()',
    },
})
export class UiTooltipDirective extends MatTooltip {
    constructor(
        protected _ref: ElementRef<HTMLElement>,
        _overlay: Overlay,
        _scrollDispatcher: ScrollDispatcher,
        _viewContainerRef: ViewContainerRef,
        _ngZone: NgZone,
        _platform: Platform,
        _ariaDescriber: AriaDescriber,
        _focusMonitor: FocusMonitor,
        @Inject(MAT_TOOLTIP_SCROLL_STRATEGY)
        _scrollStrategy: ScrollStrategy,
        @Optional()
        _dir: Directionality,
        @Optional() @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
        _defaultOptions: MatTooltipDefaultOptions,
    ) {
        super(
            _overlay,
            _ref,
            _scrollDispatcher,
            _viewContainerRef,
            _ngZone,
            _platform,
            _ariaDescriber,
            _focusMonitor,
            _scrollStrategy,
            _dir,
            _defaultOptions,
        );
        this.position = 'above';
    }
}
